module.exports = "/assets/data/da1a414e53e8e11922c8803191b60518-GU47.data.json";